import { UserRole } from '../constants/roles';

const LOGIN_PAGE = '/login';

const HOME_PAGE_BY_ROLE: Record<string, string> = {
  [UserRole.SUPERADMIN]: '/dashboard',
  [UserRole.ADMIN]: '/dashboard',
  [UserRole.WHATSAPP]: '/whatsapp-bulk-send',
};

export function getHomePage(role: string): string {
  return HOME_PAGE_BY_ROLE[role] ?? LOGIN_PAGE;
}
